import { render, staticRenderFns } from "./DhxGrid.vue?vue&type=template&id=71bec806&scoped=true&"
import script from "./DhxGrid.vue?vue&type=script&lang=js&"
export * from "./DhxGrid.vue?vue&type=script&lang=js&"
import style0 from "./DhxGrid.vue?vue&type=style&index=0&id=71bec806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bec806",
  null
  
)

export default component.exports